export enum FormFiltersType {
    INCOMPLETE_ELEMENTS,
    NOTOK_ELEMENTS,
}

export type FormFilters = Readonly<{ [key in FormFiltersType]: FormFilter }>;

export type FormFilter = Readonly<{
    filterType: FormFiltersType;
    label: string;
    visible: boolean;
}>;

export const initialFormFilters: FormFilters = {
    [FormFiltersType.INCOMPLETE_ELEMENTS]: {
        filterType: FormFiltersType.INCOMPLETE_ELEMENTS,
        label: 'FORM_FILTER_INCOMPLETE_ELEMENTS',
        visible: false,
    },
    [FormFiltersType.NOTOK_ELEMENTS]: {
        filterType: FormFiltersType.NOTOK_ELEMENTS,
        label: 'FORM_FILTER_NOT_OK_ELEMENTS',
        visible: false,
    },
};
